export type FieldType = 'numeric' | 'string' | 'boolean' | 'date' | 'datetime-local' | 'dropdown';

export function isTimeBasedFieldType(fieldType: FieldType) {
  return fieldType === 'date' || fieldType === 'datetime-local';
}
